import { useEffect } from 'react'

import NotificationHeader from '@/components/pages/Notifications/List/PageHeader'
import NotificationTable from '@/components/pages/Notifications/List/Table'
import { Notification } from '@/types'

import { useNotifications } from './Notification.hooks'

const Notifications = () => {
  const { getNotifications, getNotificationsResponse, getNotificationsLoading, updateNotification } = useNotifications()

  const handleUpdateNotification = async (id: Notification['id']) => {
    await updateNotification(id)
  }

  useEffect(() => {
    getNotifications()
  }, [getNotifications])

  return (
    <>
      <NotificationHeader />
      <NotificationTable
        dataSource={getNotificationsResponse}
        getNotificationsLoading={getNotificationsLoading}
        onUpdate={handleUpdateNotification}
      />
    </>
  )
}

Notifications.displayName = 'Notifications'
export default Notifications
